import { Link } from 'react-router-dom';

const Disclaimer = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section - Standardized */}
      <section className="bg-gradient-to-br from-slate-900 to-blue-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-5xl font-bold mb-6">Disclaimer</h1>
            <p className="text-xl text-blue-100 leading-relaxed">
              Enerlligence Analytics legal disclaimer governing the use of our information, research, and intelligence services
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8 pb-6 border-b border-slate-200">
            <p className="text-slate-600 text-sm">
              Enerlligence Analytics ("Company", "We", "Us", or "Our")
            </p>
            <p className="text-slate-500 text-sm mt-2">
              Effective Date: 1 January 2026 • Last Updated: 1 January 2026
            </p>
          </div>
          <div className="prose prose-lg max-w-none text-slate-700">
            
            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">1. General Information</h2>
            <h3 className="text-lg font-semibold text-[#1F3C88] mt-6 mb-3">Purpose</h3>
            <p className="mb-4 leading-relaxed">
              The information, data, research reports, analysis, forecasts, insights, publications, and other materials made available by Enerlligence Analytics through its website, digital platforms, publications, or services (collectively, the "Content") are provided for general informational and intelligence purposes only. The Content does not constitute, and should not be construed as: investment advice, financial advice, legal advice, tax advice, technical certification, or a recommendation to buy, sell, finance, or invest in any asset, security, commodity, or project. Users are solely responsible for obtaining independent professional advice before making business, financial, or investment decisions.
            </p>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">2. No Investment or Financial Advice</h2>
            <p className="mb-4 leading-relaxed">
              Nothing contained within the Company's Content shall be interpreted as an offer, solicitation, or recommendation to participate in any investment, financing arrangement, or commercial transaction. All investment and commercial decisions remain the sole responsibility of the user or recipient.
            </p>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">3. Accuracy of Information</h2>
            <p className="mb-4 leading-relaxed">
              While the Company endeavours to ensure that information provided is obtained from sources believed to be reliable and prepared using reasonable professional care, no representation or warranty, express or implied, is made regarding: accuracy, completeness, or reliability; timeliness or continued availability; or suitability for any particular purpose. Market conditions, regulatory environments, and industry data may change without notice.
            </p>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">4. Forward-Looking Statements</h2>
            <p className="mb-4 leading-relaxed">
              Certain Content may contain forecasts, projections, assumptions, or forward-looking statements based on current expectations and analytical models. Such statements inherently involve risks and uncertainties, and actual outcomes may differ materially from those expressed or implied. The Company undertakes no obligation to update forward-looking information.
            </p>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">5. Limitation of Liability</h2>
            <p className="mb-4 leading-relaxed">
              To the fullest extent permitted under applicable law, Enerlligence Analytics, its directors, officers, employees, affiliates, and partners shall not be liable for any: direct or indirect loss, financial or commercial loss, loss of profits or opportunity, business interruption, or consequential or incidental damages arising from reliance on or use of the Content. Use of the Company's Services and Content is at the user's own risk.
            </p>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">6. Third-Party Information and Links</h2>
            <p className="mb-4 leading-relaxed">
              The Platform may contain references to or links from third-party sources. Such references are provided solely for convenience and informational purposes. The Company does not endorse or assume responsibility for third-party content, accuracy, or practices.
            </p>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">7. Intellectual Property Rights</h2>
            <p className="mb-4 leading-relaxed">
              All Content, including research materials, graphics, databases, analytics outputs, trademarks, and proprietary methodologies, remains the intellectual property of Enerlligence Analytics, unless otherwise stated. Unauthorised reproduction, redistribution, modification, or commercial use without prior written consent is strictly prohibited.
            </p>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">8. Professional Use of Information</h2>
            <p className="mb-4 leading-relaxed">
              The Company's Content is intended primarily for professional and institutional users within the energy, mining, financial, and industrial sectors. Users acknowledge that analytical outputs represent professional opinions based on available data and methodologies rather than guarantees of performance or outcomes.
            </p>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">9. Regulatory and Jurisdictional Disclaimer</h2>
            <p className="mb-4 leading-relaxed">
              Access to the Company's Content may be restricted under certain jurisdictions. Users are responsible for ensuring compliance with applicable local laws and regulations governing the use of information services.
            </p>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">10. Technology and Platform Availability</h2>
            <p className="mb-4 leading-relaxed">
              While reasonable efforts are made to maintain uninterrupted access, the Company does not guarantee continuous availability of its digital platforms and shall not be liable for temporary interruptions arising from maintenance, cybersecurity events, or technical failures.
            </p>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">11. Updates to Disclaimer</h2>
            <p className="mb-4 leading-relaxed">
              This Disclaimer may be amended periodically to reflect operational, regulatory, or legal developments. Continued use of the Platform constitutes acceptance of any updated terms.
            </p>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">12. Contact Information</h2>
            <p className="mb-4 leading-relaxed">
              For enquiries regarding this Disclaimer:
            </p>
            <div className="bg-slate-50 p-6 rounded-lg border border-slate-200 mb-6">
              <p className="font-semibold text-[#1F3C88] mb-2">Legal & Compliance Department</p>
              <p className="text-slate-600">Enerlligence Analytics</p>
              <p className="text-slate-600">Email: <a href="mailto:legal@enerlligence.com" className="text-[#007BFF] hover:underline">legal@enerlligence.com</a></p>
              <p className="text-slate-600">Website: <a href="https://www.enerlligence.com" className="text-[#007BFF] hover:underline">www.enerlligence.com</a></p>
            </div>

            <h2 className="text-xl font-bold text-[#1F3C88] mt-8 mb-4">13. Governance Statement</h2>
            <p className="mb-4 leading-relaxed">
              The Board and Executive Management of Enerlligence Analytics maintain oversight of information integrity, responsible analytics dissemination, and risk governance to ensure adherence to internationally recognised information-service standards.
            </p>

            {/* Related Links */}
            <div className="mt-12 pt-8 border-t border-slate-200">
              <h3 className="text-lg font-semibold text-[#1F3C88] mb-4">Related Policies</h3>
              <div className="flex flex-wrap gap-4">
                <Link to="/terms-of-service" className="text-[#007BFF] hover:underline">Terms of Service</Link>
                <Link to="/privacy-policy" className="text-[#007BFF] hover:underline">Privacy Policy</Link>
                <Link to="/cookie-policy" className="text-[#007BFF] hover:underline">Cookie Policy</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Disclaimer;
